export default "__VITE_ASSET__950388eb__"